// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/**
 * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/*
* Ensure proper alignment of the vue material icons
*/
.material-design-icon[data-v-53796b97] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.dashboard-widget[data-v-53796b97] .empty-content {
  text-align: center;
  padding-top: 5vh;
}
.dashboard-widget[data-v-53796b97] .empty-content.half-screen {
  padding-top: 0;
  margin-bottom: 1vh;
}
.more[data-v-53796b97] {
  display: block;
  text-align: center;
  color: var(--color-text-maxcontrast);
  line-height: 60px;
  cursor: pointer;
}
.more[data-v-53796b97]:hover, .more[data-v-53796b97]:focus {
  background-color: var(--color-background-hover);
  border-radius: var(--border-radius-large);
  color: var(--color-main-text);
}

/* skeleton */
.item-list__entry[data-v-53796b97] {
  display: flex;
  align-items: flex-start;
  padding: 8px;
}
.item-list__entry .item-avatar[data-v-53796b97] {
  position: relative;
  margin-top: auto;
  margin-bottom: auto;
  background-color: var(--color-background-dark) !important;
}
.item-list__entry .item__details[data-v-53796b97] {
  padding-left: 8px;
  max-height: var(--default-clickable-area);
  flex-grow: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.item-list__entry .item__details h3[data-v-53796b97],
.item-list__entry .item__details .message[data-v-53796b97] {
  white-space: nowrap;
  background-color: var(--color-background-dark);
}
.item-list__entry .item__details h3[data-v-53796b97] {
  font-size: 100%;
  margin: 0;
}
.item-list__entry .item__details .message[data-v-53796b97] {
  width: 80%;
  height: 15px;
  margin-top: 5px;
}`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/vue/dist/assets/NcDashboardWidget-BSTvIgiJ.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;;;EAGE;AACF;;CAEC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,oCAAoC;EACpC,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,+CAA+C;EAC/C,yCAAyC;EACzC,6BAA6B;AAC/B;;AAEA,aAAa;AACb;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,yDAAyD;AAC3D;AACA;EACE,iBAAiB;EACjB,yCAAyC;EACzC,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;AACA;;EAEE,mBAAmB;EACnB,8CAA8C;AAChD;AACA;EACE,eAAe;EACf,SAAS;AACX;AACA;EACE,UAAU;EACV,YAAY;EACZ,eAAe;AACjB","sourcesContent":["/**\n * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/**\n * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/*\n* Ensure proper alignment of the vue material icons\n*/\n.material-design-icon[data-v-53796b97] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.dashboard-widget[data-v-53796b97] .empty-content {\n  text-align: center;\n  padding-top: 5vh;\n}\n.dashboard-widget[data-v-53796b97] .empty-content.half-screen {\n  padding-top: 0;\n  margin-bottom: 1vh;\n}\n.more[data-v-53796b97] {\n  display: block;\n  text-align: center;\n  color: var(--color-text-maxcontrast);\n  line-height: 60px;\n  cursor: pointer;\n}\n.more[data-v-53796b97]:hover, .more[data-v-53796b97]:focus {\n  background-color: var(--color-background-hover);\n  border-radius: var(--border-radius-large);\n  color: var(--color-main-text);\n}\n\n/* skeleton */\n.item-list__entry[data-v-53796b97] {\n  display: flex;\n  align-items: flex-start;\n  padding: 8px;\n}\n.item-list__entry .item-avatar[data-v-53796b97] {\n  position: relative;\n  margin-top: auto;\n  margin-bottom: auto;\n  background-color: var(--color-background-dark) !important;\n}\n.item-list__entry .item__details[data-v-53796b97] {\n  padding-left: 8px;\n  max-height: var(--default-clickable-area);\n  flex-grow: 1;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n.item-list__entry .item__details h3[data-v-53796b97],\n.item-list__entry .item__details .message[data-v-53796b97] {\n  white-space: nowrap;\n  background-color: var(--color-background-dark);\n}\n.item-list__entry .item__details h3[data-v-53796b97] {\n  font-size: 100%;\n  margin: 0;\n}\n.item-list__entry .item__details .message[data-v-53796b97] {\n  width: 80%;\n  height: 15px;\n  margin-top: 5px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
